import React from 'react';
import { render } from 'react-dom';
import PropTypes from 'prop-types';
import { PDFDownloadLink } from '@react-pdf/renderer';
import slugify from 'slugify';
import { PdfDocument } from './generate-pdf';
import Link from '@material-ui/core/Link';

export default class PDFLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };

    this.generatePDF = this.generatePDF.bind(this);
    this.buildPDF = this.buildPDF.bind(this);
    this.createAndDownloadPDF = this.createAndDownloadPDF.bind(this);
  }

  createAndDownloadPDF(pdfContent, filename, divId, callback) {
    setTimeout(() => {
      const link = (
        <div id={divId}>
          <PDFDownloadLink document={pdfContent} fileName={filename}>
            {({ loading }) => {
              //   loading ? 'Loading document...' : 'Download Pdf'
              if (!loading) {
                setTimeout(() => {
                  document.getElementById(divId).children[0].click();
                  callback();
                }, 3);
              }
            }}
          </PDFDownloadLink>
        </div>
      );
      const elem = document.createElement('div');
      document.getElementById('root').appendChild(elem);
      render(link, elem);
    }, 50);
  }

  buildPDF() {
    if (!this.state.loading) {
      this.setState({ loading: true }, () => {
        this.createAndDownloadPDF(
          this.generatePDF(),
          `${slugify(this.props.title).toUpperCase()}`,
          `${slugify(this.props.title).toLowerCase()}`,
          () => this.setState({ loading: false }),
        );
      });
    }
  }

  generatePDF() {
    //  component that returns a PDF <Document />
    return <PdfDocument {...this.props} />;
  }

  render() {
    return this.state.loading ? (
      'Loading...'
    ) : (
      <Link
        component="button"
        variant="h6"
        color="primary"
        onClick={this.buildPDF}
        style={{ paddingBottom: 10 }}
      >
        Download Contract
      </Link>
    );
  }
}

PDFLink.propTypes = {
  /* User name on the certificate */
  name: PropTypes.string.isRequired,
  /* Title of the course */
  title: PropTypes.string.isRequired,
  /* Date of completion */
  date: PropTypes.string.isRequired,
  /* Number of credits earned */
  credits: PropTypes.string.isRequired,
};
